const CARD = 'skeleton/CARD';
const LIST = 'skeleton/LIST';
const PAPER_SMALL = 'skeleton/PAPER_SMALL';
const PAPER_HUGE = 'skeleton/PAPER_HUGE';
const TABLE = 'skeleton/TABLE';
const CHECKBOX = 'skeleton/CHECKBOX';
const TEXT_INPUT = 'skeleton/TEXT_INPUT';

export const SKELETON_TYPES = {
  CARD,
  LIST,
  PAPER_SMALL,
  PAPER_HUGE,
  TABLE,
  CHECKBOX,
  TEXT_INPUT,
};
